
import LocalStorage from 'core/infrastructure/LocalStorage';

// Clave y estructura con la que persistimos en localStorage la visibilidad de las columnas de la tabla,
// para restaurarla al reabrir la pantalla. Reutilizamos el LocalStorage genérico de core/infrastructure
// (con fallback en memoria) siguiendo el mismo patrón get/save que ReservationContent.
type ColumnsVisibility = {
	showAllColumns: boolean;
	checkedColumns: Record<string, boolean>;
};

export function getColumnsVisibility(localStorageKey: string): Nullable<ColumnsVisibility> {
	const value = LocalStorage.getItem(localStorageKey);
	if (!value)
		return null;

	try {
		return JSON.parse(value) as ColumnsVisibility;
	} catch {
		return null;
	}
}

export function saveColumnsVisibility(visibility: ColumnsVisibility, localStorageKey: string): void {
	LocalStorage.setItem(localStorageKey, JSON.stringify(visibility));
}